import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ClientsTableAll, ClientsTablePaginated } from './ClientsTable.jsx';
import useSort from '../../../../shared/Sort/useSort';

export const ClientsDashboard = () => {
  const [showAll, setShowAll] = useState(false);
  const { sortingStatus, changeSort } = useSort();

  const filters = {
    ACTIVE: 'active',
    ARCHIVED: 'archived',
  };

  const currentFilter = useLocation()
    .pathname.split('/')
    .pop();

  return showAll ? (
    <ClientsTableAll
      onClick={() => setShowAll(false)}
      filter={currentFilter || filters.ACTIVE}
      sortingStatus={sortingStatus}
      changeSort={changeSort}
    />
  ) : (
    <ClientsTablePaginated
      onClick={() => setShowAll(true)}
      filter={currentFilter || filters.ACTIVE}
      sortingStatus={sortingStatus}
      changeSort={changeSort}
    />
  );
};
